import React, { useEffect } from "react";
import { Link } from "react-router";
import DOMPurify from "dompurify";
import "./generic.scss";

export default function Button({
  children,
  href,
  action = null,
  submit = false,
  disabled = false,
  title,
  target = "_blank",
  loading = false,
  id = "",
  ariaLabel = "Weiter",
  btnClass,
  name = "no_name"
}) {
  const Loading = () => <div className="loader-indicator"></div>;

  const actionWithDL = () => {
    if(window.dataLayer) {
      const UTMs = sessionStorage.getItem("utmParams") ? JSON.parse(sessionStorage.getItem("utmParams")) : false
      setTimeout(() => {
        window.dataLayer.push({
          event: "cta_click",
          cta_name: typeof(children) === "string" ? children : title || name,
          cta_url: href || (submit ? "submit" : "no_url"),
          page_name: document.title,
          user_login_source: sessionStorage.getItem("ls") || UTMs?.utm_campaign || "direct"
        })
      }, 1000)
    }
    if(action) action()
  }

  function validateLink(link) {
    let temp = link;

    if (action === null && temp === undefined && submit === false) {
      return (
        <div className={`button ${disabled ? "disabled" : ""}`} title={title} onClick={actionWithDL}>
          <div className="button-inner">{children}</div>
        </div>
      );
    } else if (submit === true) {
      return (
        <button
          aria-label={ariaLabel}
          type="submit"
          value={children}
          className={`button ${disabled ? "disabled" : ""}`}
          disabled={disabled}
          title={title}
          onClick={actionWithDL}
        >
          <div className="button-inner">{children}</div>
        </button>
      );
    } else if (action !== null && link === undefined) {
      return (
        <button
          aria-label={ariaLabel}
          className={`button ${disabled || loading ? "disabled" : ""}`}
          onClick={actionWithDL}
          title={title}
          disabled={disabled || loading}
        >
          {!loading ? (
            <div className="button-inner">{children}</div>
          ) : (
            <Loading />
          )}
        </button>
      );
    } else if (temp.includes("http://") || temp.includes("https://")) {
      return (
        <a
          href={DOMPurify.sanitize(href)}
          target={target}
          rel="noopener noreferrer"
          className={`button ${disabled ? "disabled" : ""}`}
          title={title}
          onClick={actionWithDL}
        >
          <div className="button-inner">{children}</div>
        </a>
      );
    } else {
      return (
        <Link
          to={DOMPurify.sanitize(href)}
          className={`button ${disabled || loading ? "disabled" : ""}`}
          title={title}
          onClick={actionWithDL}
        >
          {!loading ? (
            <div className="button-inner">{children}</div>
          ) : (
            <Loading />
          )}
        </Link>
      );
    }
  }

  return (
    <div
      id={id}
      className={`button-component ${disabled || loading ? "disabled" : ""} ${btnClass ? btnClass : ""}`}
    >
      {validateLink(href)}
    </div>
  );
}
